import type { StaffMe } from '@central/api';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { keys } from '../api';

/**
 * Finishes a sign-in: seeds auth/me with the StaffMe the last step returned
 * (or drops it, so the guarded route asks the server, when the step returned
 * none) and opens the overview.
 */
export function useSignedIn() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  return async (me?: StaffMe) => {
    if (me) queryClient.setQueryData(keys.me, me);
    else queryClient.removeQueries({ queryKey: keys.me });
    await navigate({ to: '/' });
  };
}
